import clsx from "clsx";
import { z } from "zod";

import { useSuiQueryContext } from "@/context/SUIQuery/useSuiQueryContext";
import { Button } from "@/ui/nextui/Button/Button";
import { Card } from "@/ui/nextui/Card/Card";

import { PurchaseLicenseFormSchema } from "../Dashboard/Dashboard.types";
import { PurchaseLicenseForm } from "../form/PurchaseLicenseForm/PurchaseLicenseForm";
import { LicenseSaleTreasury } from "../sui/LicenseSaleTreasury/LicenseSaleTreasury";
import { PurchaseLicenseProps } from "./PurchaseLicense.types";

export const PurchaseLicense: React.FC<PurchaseLicenseProps> = ({ className }) => {
  const { purchaseLicense, purchaseLicenseForm, currentAccountCoins } = useSuiQueryContext();

  function onSubmit(values: z.infer<typeof PurchaseLicenseFormSchema>) {
    // @TODO Display an error if the current account has no coin balance
    if (!currentAccountCoins.coinWithHighestBalance?.objectId) return;

    const referralCode = values.referralCode;

    purchaseLicense(
      {
        referralCode: referralCode || "",
        quantity: Number(values.quantity),
        coinObjectId: currentAccountCoins.coinWithHighestBalance.objectId,
      },
      {
        onSuccessCallback: () => {},
      },
    );
  }

  return (
    <section className={clsx("", className)} id="purchase-license">
      <LicenseSaleTreasury />

      <div className="container">
        <div className="sm:flex">
          <div className="hidden w-6/12 flex-col items-center justify-center sm:flex">
            <img alt="agent-license" loading="lazy" src="/agent-license-face.gif" />
            <img alt="agent-license" loading="lazy" src="/agent-license-flicker.gif" />
          </div>
          <div className="flex min-h-screen w-full flex-col justify-end pb-[18px] pt-[180px] sm:w-6/12 sm:items-center sm:justify-center sm:py-[180px]">
            <PurchaseLicenseForm onSubmit={purchaseLicenseForm.handleSubmit(onSubmit)}>
              <Card className="w-full sm:w-[410px]">
                <Card.Header className="block">
                  <h1 className="text-3xl">Agent License</h1>
                </Card.Header>
                <Card.Body className="flex flex-col gap-4 py-4">
                  <PurchaseLicenseForm.Body />
                </Card.Body>
                <Card.Footer className="px-0">
                  <Button fullWidth color="success" size="lg" type="submit">
                    Buy Now
                  </Button>
                </Card.Footer>
              </Card>
            </PurchaseLicenseForm>
          </div>
        </div>
      </div>
    </section>
  );
};
